module.exports = __webpack_public_path__ + "img/sea.aa4fca85.jpg";